import React, { useState, useEffect } from "react";
import { BASE_IMAGE_API_URL, BASE_API_URL } from "../../services/baseServices";
import axios from "axios";
import { Select } from 'antd';
import { GET_DDL_ITEMS } from "../../services/commonServices";
import { ADD_UPDATE_CONTENT_BY_TYPE } from "../../services/contentByTypeServices";
import ReactQuill from 'react-quill';
import { useOffcanvasReset } from "../../hooks/useOffcanvasReset";
import Swal from 'sweetalert2';

    export default function AddContentByType() {
        
        const [contentTypeData, setContentTypeData] = useState([]);
        const [images, setImages] = useState([]);
        const [loading, setLoading] = useState(false);
        const [sessionUserData, setSessionUserData] = useState([]);
        const [formData, setFormData] = useState({
            Title: '',
            Description1: '',
            Description2: '',
            Images: '',
            IconName: '',
            ContentTypeId: ''
        });

        useEffect(() => {
            const userDataString = sessionStorage.getItem("userData");
            if (userDataString) {
                const userData = JSON.parse(userDataString);
                setSessionUserData(userData);
            } else {
                console.log("data not available ins session");
            }
        }, []);

        const { Option } = Select;

        useEffect(() => {
            if (sessionUserData?.OrgId && sessionUserData?.Id) {
                fetchContentByType();
            }
        }, [sessionUserData]);

        const fetchContentByType = async () => {
            try {
                const response = await axios.get(`${BASE_API_URL}${GET_DDL_ITEMS}?OrgId=${sessionUserData?.OrgId}&UserId=${sessionUserData?.Id}`);
                const allItems = response.data.ResultData;
                const contentTypesRes = allItems.filter(item => item.DDLName === "ContentTypes");
                setContentTypeData(contentTypesRes);
            } catch (error) {
                console.error("Error fetching content types:", error);
            }
        };

        const handleChange = (e) => {
            const { name, value } = e.target;
            setFormData(prev => ({ ...prev, [name]: value }));
        };

        const handleImageChange = (e) => {
            const files = Array.from(e.target.files);
            const newImages = files.map(file => ({
                file,
                preview: URL.createObjectURL(file)
            }));
            setImages(prev => [...prev, ...newImages]);
        };
        
        const removeImage = (indexToRemove) => {
            setImages(prev => prev.filter((_, idx) => idx !== indexToRemove));
        };        

        const handleSubmit = async (e) => {
            e.preventDefault();

            const submissionData = new FormData();
            submissionData.append("Id", 0);
            submissionData.append("Title", formData.Title);
            submissionData.append("Description1", formData.Description1);
            submissionData.append("Description2", formData.Description2);
            submissionData.append("IconName", formData.IconName);
            submissionData.append("ContentTypeId", formData.ContentTypeId);
            submissionData.append("IsActive", 1);
            submissionData.append("OrgId", sessionUserData?.OrgId);
            submissionData.append("UpdatedBy", sessionUserData?.Id);
            submissionData.append("CreatedBy", sessionUserData?.Id);
        
            images.forEach((imgObj) => {
                submissionData.append("images", imgObj.file);
            });
        
            setLoading(true);
            const payloadLog = {};
            for (let [key, value] of submissionData.entries()) {
                if (value instanceof File) {
                    if (!payloadLog[key]) {
                        payloadLog[key] = [];
                    }
                    payloadLog[key].push(value.name); 
                } else {
                    payloadLog[key] = value;
                }
            }
                    console.log("FormData Payload:", payloadLog);
        
            try {
                const response = await axios.post(`${BASE_API_URL}${ADD_UPDATE_CONTENT_BY_TYPE}`, submissionData);
        
                setLoading(false);
                if (response.data.ResultData.Status === 'Success') {
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: 'Content added successfully!',
                    }).then(() => {
                        setLoading(false);
                        // window.location.reload();
                    });
                } else {
                    setLoading(false);
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'Failed to add content. Please try again.',
                    });
                }
        
            } catch (error) {
                setLoading(false);
                console.error("Add content failed", error);
        
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Failed to add content. Please try again.',
                });
            }
        };
              

        const resetForm = () => {
            setFormData({
                Title: '',
                Description1: '',
                Description2: '',
                Images: '',
                IconName: ''
            });
            setImages([]);
        };        

        useOffcanvasReset('offcanvasRightAdd', resetForm);

        return (
            <div className="offcanvas offcanvas-end" tabIndex="-1" id="offcanvasRightAdd" aria-labelledby="offcanvasRightLabel" style={{ minWidth: "45%", maxWidth: "45%" }}>
                <form autoComplete="off" onSubmit={handleSubmit}>
                    <div className="offcanvas-header d-flex justify-content-between align-items-center">
                        <h5 id="offcanvasRightLabel">Add Content by Type</h5>
                        <div className="d-flex align-items-center">
                            <button 
                                className="btn btn-primary" 
                                disabled={loading}
                                type="submit"
                            >{loading ? 'Submitting...' : 'Submit'}</button>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="offcanvas"
                                aria-label="Close"
                                onClick={resetForm}
                            ></button>
                        </div>
                    </div>

                    <div className="offcanvas-body" style={{ maxHeight: "42rem", overflowY: "auto" }}>
                        <div className="row">
                            <div className="col-6 mb-2">
                                <label className="form-label">Title<span className="text-danger">*</span></label>
                                <input
                                    name="Title"
                                    className="form-control"
                                    value={formData.Title}
                                    onChange={handleChange}
                                    placeholder="Enter title"
                                />
                            </div>

                            <div className="col-6 mb-2">
                                <label className="form-label">Content Type<span className="text-danger">*</span></label>
                                <Select
                                    placeholder="Choose Content Type"
                                    showSearch
                                    allowClear
                                    value={formData.ContentTypeId}
                                    style={{ width: '100%', height: 42 }}
                                    optionFilterProp="children"
                                    onChange={(value) => setFormData(prev => ({ ...prev, ContentTypeId: value }))}
                                >
                                    {contentTypeData?.map(item => (
                                        <Option key={item.ItemId} value={item.ItemId}>
                                            {item.ItemValue}
                                        </Option>
                                    ))}
                                </Select>
                            </div>

                            <div className="col-6 mb-2">
                                <label className="form-label">Icon (HTML)</label>
                                <input
                                    name="IconName"
                                    className="form-control"
                                    value={formData.IconName}
                                    onChange={handleChange}
                                    placeholder="Choose Icon"
                                />
                                <div dangerouslySetInnerHTML={{ __html: formData.IconName }} className="mt-1" />
                            </div>

                            <div className="col-12 mb-5">
                                <label className="form-label">Description 1<span className="text-danger">*</span></label>
                                <ReactQuill
                                    theme="snow"
                                    value={formData.Description1}
                                    onChange={(value) => setFormData({ ...formData, Description1: value })}
                                    placeholder="Enter description-1"
                                    style={{ height: '100px' }}
                                />
                            </div>

                            <div className="col-12 mb-5">
                                <label className="form-label">Description 2</label>
                                <ReactQuill
                                    theme="snow"
                                    value={formData.Description2}
                                    onChange={(value) => setFormData({ ...formData, Description2: value })}
                                    placeholder="Enter description-2"
                                    style={{ height: '100px' }}
                                />
                            </div>

                            <div className="col-12 my-3">
                                <label className="form-label">Upload Images<span className="text-danger">*</span></label>
                                <input
                                    type="file"
                                    name="Images"
                                    accept="image/*"
                                    className="form-control mb-2"
                                    multiple
                                    onChange={handleImageChange}
                                />

                                <div className="d-flex flex-wrap gap-2 mt-3">
                                    {images.map((img, idx) => (
                                        <div key={idx} style={{ position: 'relative' }}>
                                            <img
                                                src={img.preview}
                                                alt={`Preview ${idx}`}
                                                style={{ width: '140px', height: '140px', objectFit: 'cover', borderRadius: '6px', border: '1px solid #ddd' }}
                                            />
                                            <button
                                                type="button"
                                                onClick={() => removeImage(idx)}
                                                style={{
                                                    position: 'absolute',
                                                    top: '-5px',
                                                    right: '-5px',
                                                    background: '#dc3545',
                                                    color: '#fff',
                                                    border: 'none',
                                                    borderRadius: '50%',
                                                    width: '20px',
                                                    height: '20px',
                                                    fontSize: '12px',
                                                    cursor: 'pointer',
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center'
                                                }}
                                            >
                                                ✖
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        );
    }
